module.exports = __webpack_public_path__ + "static/media/Pixendorf.91179df4.webp";